import React, { useState } from 'react';
import { Button, DatePicker, Drawer, Result, Space, notification } from 'antd';
import { useUpdateAuctionMutation } from '../../../app/api/auctionApiSlice';
import Auction from '../../../core/models/Auction';
import moment, { Moment } from 'moment';
import { RangePickerProps } from 'antd/lib/date-picker';

interface IProps {
  auction?: Auction;
}

const CreateAuction: React.FC<IProps> = ({ auction }) => {
  const [updateAuction, { isLoading: isUpdateAuctionLoading }] = useUpdateAuctionMutation();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const [auctionDateTime, setAuctionDateTime] = useState<Moment | null>();

  const handleUpdateAuction = (): void => {
    void (async () => {
      if (auctionDateTime) {
        updateAuction(auctionDateTime?.toDate())
          .unwrap()
          .then(() => {
            notification.success({
              message: 'Update Auction',
              description: 'Auction updated successfully',
            });

            setDrawerVisible(false);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        notification.error({
          message: 'Update Auction',
          description: 'Please select a valid date and time',
        });
      }
    })();
  };

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    // Can not select days before today and today
    return current && current < moment().endOf('day');
  };

  return (
    <>
      {!auction && (
        <Result
          status='info'
          title='No Active Auction'
          extra={[
            <Button type='primary' key='create' onClick={() => setDrawerVisible(true)}>
              Create New Auction
            </Button>,
          ]}
        />
      )}
      {auction && auction.status.id === 1 && (
        <Button type='ghost' onClick={() => setDrawerVisible(true)} style={{ marginLeft: 'auto' }}>
          Change Auction Date/Time
        </Button>
      )}
      <Drawer
        title='Auction Date/Time'
        width={300}
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Space direction='vertical'>
          Auction Date/Time
          <DatePicker
            disabledDate={disabledDate}
            showTime={{ defaultValue: moment('12:00:00', 'HH:mm:ss') }}
            format='YYYY-MM-DD HH:mm'
            onOk={(value) => {
              setAuctionDateTime(value);
            }}
          />
          <Button type='primary' onClick={handleUpdateAuction} loading={isUpdateAuctionLoading}>
            Create Auction
          </Button>
        </Space>
      </Drawer>
    </>
  );
};

export default CreateAuction;
